import React from 'react';
import classes from "./styles.module.scss";
import Body from '@/ui/Body';
import Title from '@/ui/Title';
import Link from 'next/link';

const Specialisms = ({ className, items }) => {

  items = items.sort((a, b) => a.sequence - b.sequence);

  return (
    <div className={`${classes.specialisms} ${className}`}>
      <div className={classes.header}>
        <Title tag="h2" title="SPECIALISMS" className={`highlight primary text-white`} highlight={true} variant="primary" />
      </div>
      <div className={classes.tiles} >
        {items.map(({ discipline, description, link }, k) => (
          <div key={k} className={classes.tile}>
            <Link href={link}>
              <div className={classes.titleCont}>
                <img alt={discipline} src="/specialism_image.svg" className={classes.image} />
                  <Title tag="span" title={discipline} className={`${classes.title} h4`} />
              </div>
            </Link>
            <Body body={description} className={classes.body} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default Specialisms